import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    style: translate({ id: 'rm.contextual.place.style' }),
    styleAll: translate({ id: 'rm.contextual.place.styleAll' }),
  }))

  return api
}
